export default __webpack_public_path__ + "locales/de/Settings.json?hash=9fc24bc95043abd2efda30fa09946b05";